/**
 * Stock Search API functions
 */
import { ENDPOINTS } from './endpoints';
import { getRequestBackendDataV2 } from './core';

export async function searchStocksV2(auth, callback, query, limit = 10) {
    await getRequestBackendDataV2(auth, callback, ENDPOINTS.STOCK.SEARCH(query, limit));
}

